import './setup-console';
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./lib/i18n";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
